<template>
    <div>
        <div class="footer-box">
            <div class="logo-box">
                <img src="../assets/logo_1.png" class="logo">
                <img src="../assets/link_2.png" class="link">
            </div>
            <div class="foot-menu">
                <div class="company">
                    <div>Company</div>
                    <p :class="step == 1 ? 'select' : ''" @click="selectMenu(1)">HOME</p>
                    <p :class="step == 2 ? 'select' : ''" @click="selectMenu(2)">ABOUT US</p>
                    <p :class="step == 3 ? 'select' : ''" @click="selectMenu(3)">NEWS</p>
                    <p :class="step == 4 ? 'select' : ''" @click="selectMenu(4)">PRIVACY POLICY</p>
                </div>
                <div class="contact">
                    <div>Contact</div>
                    <p class="addlin">FLAT/RM A 12/F ZJ 300 300LOCKHART RD WAN CHAI HONG KONG</p>
                    <p><img src="../assets/email.png" class="email">henry@hami-tech.com</p>
                    <p><img src="../assets/tel_1.png" class="email">00852+81112378</p>
                </div>
                <div class="newsletter">
                    <div>Newsletter</div>
                    <input type="text" class="input-box" placeholder="Email Address">
                    <div class="sub-btn">Subscribe</div>
                </div>
            </div>
        </div>
        <div class="hatful">©2024 All rights Hami-Happy Tech Co., Limited</div>
    </div>
</template>

<script>
export default {
    name: "footer",
    data() {
        return {
            time: '2024'
        };
    },
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    methods: {
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "AboutUs" }); break;
                case 3: this.$router.push({ path: "News" }); break;
                case 4: this.$router.push({ path: "Privacy" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.footer-box {
    background: #1E1729;
    padding: 0px 360px;

    .logo-box {
        height: 150px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo {
            height: 36px;
        }

        .link {
            height: 41px;
        }
    }

    .foot-menu {
        padding: 60px 0px;
        display: flex;
        // justify-content: space-between;

        .company {
            width: 400px;

            div {
                font-weight: bold;
                font-size: 28px;
                color: #FFFFFF;
            }

            p {
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 80px;
                cursor: pointer;
            }

            .select {
                font-weight: bold;
                color: #602EDF;
            }
        }

        .contact {
            width: 1000px;
            margin-left: 100px;

            div {
                font-weight: bold;
                font-size: 28px;
                color: #FFFFFF;
            }

            p {
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 80px;
                display: flex;
                align-items: center;

                img {
                    width: 30px;
                    margin-right: 10px;
                }
            }

            .addlin {
                line-height: normal;
                margin-top: 60px;
            }
        }

        .newsletter {
            margin-left: 100px;

            div {
                font-weight: bold;
                font-size: 28px;
                color: #FFFFFF;
            }

            .input-box {
                margin-top: 60px;
                width: 342px;
                height: 36px;
                background: #FFFFFF;
                border-radius: 20px 20px 20px 20px;
                padding: 20px;
            }

            .sub-btn {
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                width: 153px;
                height: 70px;
                background: #5F2DDE;
                border-radius: 20px 20px 20px 20px;
                line-height: 70px;
                align-items: center;
                text-align: center;
                margin-top: 40px;
            }
        }
    }
}

.hatful {
    height: 84px;
    background: #000000;
    border-radius: 0px 0px 0px 0px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    line-height: 84px;
}
</style>